"use strict";
const angular = require("angular");

import _ from "underscore";
import Siret from "siret";

import countries from "./../countries";
//var  countriesEn = require('./countries-en');
//var  countriesFr = require('./countries-fr');
//var  countries = require('./../countries');

export class ClientController {
  constructor(IdentificationAPI, gettextCatalog, $http, localStorageService) {
    "ngInject";
    var that = this;
    this.$http = $http;
    this.IdentificationAPI = IdentificationAPI;
    this.Siret = Siret;
    this.gettextCatalog = gettextCatalog;
    this.localStorageService = localStorageService;

    /*
    this.countries = [];
    for (var j in countriesFr.default) {
      this.countries.push({
        nameFr:countriesFr.default[j] ,
        nameEn:countriesEn.default[j]||countriesFr.default[j] ,
        code:j
      });
    }
    */
    this.countries = countries;
    this.categories = [
      "Agence de publicité",
      "Agence Photo / Photothèque",
      "Association",
      "Autre",
      "Avocat",
      "Banque",
      "Centre d'art",
      "Commissaire priseur",
      "Diffuseur",
      "Distributeur",
      "Editeur",
      "Fabricant",
      "Fondation",
      "FRAC",
      "Galerie",
      /*,
           'Iconographe'*/
      "Musée",
      "Notaire" /*, 'Particulier'*/,
      "Presse",
      "Prestataire",
      "Producteur",
      "Professionnel du marché de l'art",
      "Société d'auteurs",
      "Université, école",
    ];

    this.$onInit = function () {
      let parameters = that.resolve.parameters;
      that.action = parameters.action;
      that.type = parameters.type;
      that.data = parameters.data;
      that.userId = parameters.userId;
      that.contact.privateIndividual = false;
      that.enableSave = true;
      that.isSiret = false;
      that.isVatNumber = false;
      that.importedAddress = null;
      if (that.type === "contact") {
        that.isContact = true;
        that.title = this.gettextCatalog.getString("Fiche contact");
        that.contact = JSON.parse(JSON.stringify(that.data));
        if (
          that.contact &&
          that.contact.createdBy &&
          that.contact.createdBy != that.userId
        ) {
          that.enableSave = false;
        }
      } else if (that.type === "society") {
        that.isSociety = true;
        that.title = this.gettextCatalog.getString("Fiche société");
        that.society = JSON.parse(JSON.stringify(that.data));
        if (
          that.society &&
          that.society.createdBy &&
          that.society.createdBy != that.userId
        ) {
          that.enableSave = false;
        }
        if (this.action == "update") {
          if (that.society.siret) {
            that.checkSiret(true);
            that.showSiretError = true;
          } else {
            // that.society.hasNotSiret = true;
          }

          if (that.society.vatNumber) {
            that.checkVatNumber();
            that.showVatNumberError = true;
          } else {
            // that.society.hasNotVatNumber = true;
          }
        }
      } else if (that.type === "address") {
        that.isAddress = true;
        that.title = this.gettextCatalog.getString("Fiche adresse");
        that.address = JSON.parse(JSON.stringify(that.data));
        if (that.address && that.address.country) {
          that.address.objCountry = _.findWhere(that.countries, {
            nameFr: that.address.country,
          });
        }
        if (
          that.address &&
          that.address.createdBy &&
          that.address.createdBy != that.userId
        ) {
          that.enableSave = false;
        }
        let importedAddress = that.localStorageService.get("imported_address");
        if (that.action == "create" && importedAddress) {
          that.importAddress(importedAddress);
          localStorage.removeItem("ls.imported_address");
        }
      } else if (that.type === "full") {
        that.isFull = true;
        that.title = this.gettextCatalog.getString("Fiche ");
      }
    };

    this.cancel = function () {
      this.dismiss({
        $value: "On annule",
      });
    };
    this.contact = {
      type: "individual",
    };
  }

  importAddress(address) {
    // this.address = {};
    this.address.line1 = address.line1;
    this.address.zip = address.zip;
    this.address.city = address.city;
    this.address.objCountry = _.findWhere(this.countries, { code: "FR" });
    this.address.country = this.address.objCountry
      ? this.address.objCountry.nameFr
      : null;
  }

  checkSiret(dontUseData) {
    let that = this;
    this.isSiret = false;
    that.importedAddress = null;
    if (this.society.siret) {
      this.society.siret = this.society.siret.trim();
      this.society.siret = this.society.siret.replace(/\s/g, "");
      this.society.siret = this.society.siret.replace(/[^0-9]/g, "");
      //this.Siret.isSIRET(this.society.siret) || this.Siret.isSIREN(this.society.siret);
      if (this.Siret.isSIRET(this.society.siret)) {
        return this.IdentificationAPI.checkSiret({
          siret: this.society.siret,
        })
          .$promise.then((resp) => {
            resp = JSON.parse(JSON.stringify(resp));
            if (resp && resp.forceSiret) {
              this.isSiret = true;
            }
            if (resp && resp.etablissement) {
              this.isSiret = true;
              if (!dontUseData) {
                let etablissement = resp.etablissement;
                that.society.name =
                  etablissement.uniteLegale.denominationUniteLegale;

                let _address = etablissement.adresseEtablissement;
                let line1 = "";
                if (_address.numeroVoieEtablissement) {
                  line1 += `${_address.numeroVoieEtablissement} `;
                }
                if (_address.indiceRepetitionEtablissement) {
                  line1 += `${_address.indiceRepetitionEtablissement} `;
                }
                if (_address.typeVoieEtablissement) {
                  line1 += `${_address.typeVoieEtablissement} `;
                }
                if (_address.libelleVoieEtablissement) {
                  line1 += `${_address.libelleVoieEtablissement} `;
                }
                line1 = line1.trim();

                that.importedAddress = {
                  line1: line1,
                  line2: _address.complementAdresseEtablissement,
                  zip: _address.codePostalEtablissement,
                  city: _address.libelleCommuneEtablissement,
                };
                if (that.type == "full") {
                  that.importAddress(that.importedAddress);
                }
              }
            }
          })
          .catch((err) => {});
      }
    }
  }

  checkVatNumber() {
    let that = this;
    this.isVatNumber = false;
    if (this.society.vatNumber) {
      this.society.vatNumber = this.society.vatNumber.trim().toUpperCase();
      this.society.vatNumber = this.society.vatNumber.replace(/\s/g, "");
      this.society.vatNumber = this.society.vatNumber.replace(
        /[^a-zA-Z0-9]/g,
        ""
      );
      if (this.society.vatNumber.length >= 10) {
        return this.IdentificationAPI.checkVatNumber({
          countryCode: this.society.vatNumber.substring(0, 2),
          vatNumber: this.society.vatNumber.substring(2),
        })
          .$promise.then((resp) => {
            resp = JSON.parse(JSON.stringify(resp));
            // console.log(resp);
            if (resp.valid) {
              that.isVatNumber = true;
            }
          })
          .catch((err) => {});
      }
    }
  }

  searchCountries(query) {
    if (!query || String(query).length < 2) {
      return [];
    }
    const q = String(query).toLowerCase();
    return this.countries
      .filter((country) => country.nameFr.toLowerCase().indexOf(q) !== -1)
      .sort((a, b) => {
        const rank = (name) => (name.toLowerCase().indexOf(q) === 0 ? 0 : 1);
        return (
          rank(a.nameFr) - rank(b.nameFr) ||
          a.nameFr.localeCompare(b.nameFr, "fr")
        );
      });
  }

  countrySelected(objCountry) {
    const match =
      objCountry &&
      _.findWhere(this.countries, {
        nameFr: objCountry.nameFr,
        code: objCountry.code,
      });
    if (!match) {
      this.address.country = null;
      this.address.objCountry = null;
      return;
    }
    this.address.country = match.nameFr;
    this.address.objCountry = match;
  }

  clearCountry() {
    this.address.objCountry = null;
    this.address.country = null;
  }

  save(form) {
    if (this.contact) {
      this.contact.privateIndividual = !!this.contact.privateIndividual;
    }
    // if (this.society && this.society.siret && (this.type === 'full' || this.type === 'society')) {
    //   this.society.siret = this.society.siret.replace(/\s+/g, '');
    //   isSiretValid = this.Siret.isSIRET(this.society.siret) || this.Siret.isSIREN(this.society.siret);
    //   form.siret.$invalid = !isSiretValid;
    // }
    if (this.society && !this.society.isFrenchRegisteredCompany) {
      this.society.siret = null;
    }
    if (this.society && !this.society.hasVatNumber) {
      this.society.vatNumber = null;
    }

    this.submitted = true;
    if (form.$valid) {
      if (this.action === "create" && this.type === "full") {
        this.createClient();
      } else if (this.action === "create" && this.type === "contact") {
        let _data = JSON.parse(JSON.stringify(this.contact));
        if (this.contact.privateIndividual) {
          this.society = this.society || {};
          this.society.name = `${this.contact.firstname} ${this.contact.lastname}`;
          this.society.hasVatNumber = false;
          this.society.isFrenchRegisteredCompany = false;
          _data.society = this.society;
        }
        this.api(this.IdentificationAPI.createContact, _data);
      } else if (this.action === "create" && this.type === "society") {
        if (this.importedAddress) {
          this.localStorageService.set(
            "imported_address",
            this.importedAddress
          );
        }
        this.api(this.IdentificationAPI.createSociety, this.society);
      } else if (this.action === "create" && this.type === "address") {
        this.api(this.IdentificationAPI.createAddress, this.address);
      } else if (this.action === "update" && this.type === "contact") {
        this.api(this.IdentificationAPI.updateContact, this.contact);
      } else if (this.action === "update" && this.type === "society") {
        this.api(this.IdentificationAPI.updateSociety, this.society);
      } else if (this.action === "update" && this.type === "address") {
        this.api(this.IdentificationAPI.updateAddress, this.address);
      }
    }
  }

  delete() {
    if (this.type === "contact") {
      this.api(this.IdentificationAPI.deleteContact, this.contact);
    } else if (this.type === "society") {
      this.api(this.IdentificationAPI.deleteSociety, this.society);
    } else if (this.type === "address") {
      this.api(this.IdentificationAPI.deleteAddress, this.address);
    }
  }

  api(service, data) {
    var that = this;
    service(data)
      .$promise.then((response) => {
        let res = {};
        if (response) {
          response = JSON.parse(JSON.stringify(response));
          if (
            this.action === "create" &&
            this.type === "contact" &&
            data.privateIndividual
          ) {
            res = {
              contact: response.id,
              society: response.societyId,
            };
          } else if (
            this.action === "create" &&
            this.type === "address" &&
            data.isPriviteAndNoSociety
          ) {
            res = {
              society: response.clientId,
              address: response.id,
            };
          } else {
            res[that.type] = response.id;
          }
        }
        that.close({
          $value: res,
        });
        return null;
      })
      .catch((err) => {
        //console.log(err);
        if (err.status == 403) {
          that.isForbiddenOwnerDelete = true;
        }
        //console.log(`Error on api ${that.type}`);
        return;
      }); // @@@ Handle popup
  }

  createClient() {
    var that = this;
    if (this.contact.privateIndividual) {
      let society = {
        name: `${this.contact.firstname} ${this.contact.lastname}`,
        hasVatNumber: false,
        isFrenchRegisteredCompany: false,
        //category: 'Particulier',
        website:
          this.society && this.society.website ? this.society.website : null,
      };
      this.society = society;
    }
    this.IdentificationAPI.createClient({
      contact: that.contact,
      society: that.society,
      address: that.address,
      isOwner: this.data ? this.data.isOwner : null,
    })
      .$promise.then((response) => {
        response = JSON.parse(JSON.stringify(response));
        this.close({
          $value: {
            contact: response.id,
            society: response.society.id,
            address: response.society.address[0].id,
          },
        });
        return null;
      })
      .catch(() => {
        //console.log('Error on create client');
        return;
      }); // @@@ Handle popup
  }
}

export default angular
  .module("dalApp.permission.client", [])
  .component("client", {
    template: require("./client.html"),
    controller: ClientController,
    bindings: {
      resolve: "<",
      close: "&",
      dismiss: "&",
    },
  }).name;



// WEBPACK FOOTER //
// ./client/app/permission/client/client.component.js